/**
  Author: Ravinder Singh - ravinder.singh@enabledata.com
  Purpose: Report model actions
  Date: Sept 2020
**/

import { action, thunk } from 'easy-peasy';
import * as reportService from '../../services/report';

const reportModel = {
  standardReportList: [],
  standardReport: '',
  sourceList: [],

  setSourceList: action((state, payload) => {
    state.sourceList = payload;
  }),
  getSourceList: thunk(async (actions, payload) => {
    return await reportService
      .getSourceList(payload)
      .then(function (response) {
        actions.setSourceList(response?.data?.data?.users);
        return response?.data?.data?.users;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setSourceList([]);
      });
  }),
  setStandardReportList: action((state, payload) => {
    state.standardReportList = payload;
  }),
  setStandardReport: action((state, payload) => {
    state.standardReport = payload;
  }),
  getStandardReport: thunk(async (actions, payload) => {
    return await reportService
      .getStandardReport(payload)
      .then(function (response) {
        actions.setStandardReport(response.data.data);
        return response.data.data;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setStandardReport({});
      });
  }),
  getStandardReportList: thunk(async (actions, payload) => {
    await reportService
      .getStandardReportList(payload)
      .then(function (response) {
        actions.setStandardReportList(response.data.data.items);
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setStandardReportList([]);
      });
  }),

  customReport: '',
  setCustomReport: action((state, payload) => {
    state.customReport = payload;
  }),
  getCustomReport: thunk(async (actions, payload) => {
    return await reportService
      .getCustomReport(payload)
      .then(function (response) {
        actions.setCustomReport(response.data.data);
        return response.data.data;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setCustomReport({});
      });
  }),

  customReportList: [],
  setCustomReportList: action((state, payload) => {
    state.customReportList = payload;
  }),

  setEventLogs: action((state, payload) => {
    state.eventLogs = payload;
  }),
  customReportListLoader: false,
  setCustomReportListLoader: action((state, payload) => {
    state.customReportListLoader = payload;
  }),
  getCustomReportList: thunk(async (actions, payload) => {
    await reportService
      .getCustomReportList(payload)
      .then(function (response) {
        actions.setCustomReportListLoader(false);
        actions.setCustomReportList(response.data.data.items);
      })
      .catch(function (error) {
        actions.setCustomReportListLoader(false);
        actions.setCustomReportList([]);
      });
  }),

  getEventLogs: thunk(async (actions, payload) => {
    await reportService
      .getEventLogs(payload)
      .then(function (response) {
        actions.setCustomReportListLoader(false);
        actions.setEventLogs(response.data);
      })
      .catch(function (error) {
        actions.setCustomReportListLoader(false);
        actions.setEventLogs([]);
      });
  }),

  entityTypeList: {},
  associationTypeList: {},
  setEntityTypeList: action((state, payload) => {
    const entityLsit = {};
    Object.keys(payload).forEach((val) => {
      entityLsit[val] = {};
      entityLsit[val].label = payload[val].label;
      entityLsit[val].meta = [];
      entityLsit[val].associations = payload[val].associations;
      payload[val].meta && payload[val].meta.forEach((metaVal, index) => {
        metaVal.name = 'entity-' + val + '-' + metaVal.name;
        if (val !== 'transactions') {
          metaVal.label = payload[val].label + ' ' + metaVal.label;
        }

        entityLsit[val].meta.push(metaVal);
      });
    });
    state.entityTypeList = entityLsit;
  }),
  setAssociationTypeList: action((state, payload) => {
    const associationLsit = {};
    Object.keys(payload).forEach((val) => {
      associationLsit[val] = {};
      associationLsit[val].label = payload[val].label;
      associationLsit[val].meta = [];
      payload[val].meta && payload[val].meta.forEach((metaVal, index) => {
        metaVal.name = 'asso-' + val + '-' + metaVal.name;

        if (metaVal.name.includes('effectivedate') || metaVal.name.includes('inactivedate')) {
          metaVal.label = 'Associated ' + metaVal.label;
        } else {
          metaVal.label = payload[val].label + ' ' + metaVal.label;
        }

        associationLsit[val].meta.push(metaVal);
      });
    });

    state.associationTypeList = associationLsit;
  }),
  setDownloadUserLogs: action((state, payload) => {
    state.downloadUserLogsList = payload;
  }),
  getEntityTypeList: thunk(async (actions, payload) => {
    return await reportService
      .getDataList(payload)
      .then(function (response) {
        actions.setEntityTypeList(response.data);
        return response;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setEntityTypeList({});
        return error;
      });
  }),
  getAssociationTypeList: thunk(async (actions, payload) => {
    return await reportService
      .getDataList(payload)
      .then(function (response) {
        actions.setAssociationTypeList(response.data);
        return response;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setAssociationTypeList({});
        return error;
      });
  }),
  addCustomReport: thunk(async (actions, payload) => {
    return await reportService.addCustomReport(payload);
  }),
  downloadUserLogs: thunk(async (actions, payload) => {
    return await reportService.downloadUserLogs(payload)
    .then(function (response) {
      actions.setDownloadUserLogs(response.data);
      return response;
    })
    .catch(function (error) {
      console.log('Error', error);
      actions.setDownloadUserLogs({});
      return error;
    });
  }),
  updateaddCustomReport: thunk(async (actions, payload) => {
    return await reportService.updateCustomReport(payload);
  }),
  deleteCustomReport: thunk(async (actions, payload) => {
    return await reportService.deleteCustomReport(payload);
  }),
  reportresultList: [],
  setReportresultList: action((state, payload) => {
    state.reportresultList = payload;
  }),
  reportFileUrl: [],
  setReportFileUrl: action((state, payload) => {
    state.reportFileUrl = payload;
  }),
  userNotificationsList: [],
  setUserNotificationsList: action((state, payload) => {
    state.userNotificationsList = payload;
  }),
  getReportresultList: thunk(async (actions, payload) => {
    actions.setReportresultList([]);
    await reportService
      .getReportresultList(payload)
      .then(function (response) {
        actions.setReportresultList(response.data.data);
        return response.data.data;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setReportresultList([]);
        return error
      });

  }),

  getReportFile: thunk(async (actions, payload) => {
    actions.setReportFileUrl([]);
    await reportService
      .getReportFile(payload)
      .then(function (response) {
        actions.setReportFileUrl(response);
        return response;
      })
      .catch(function (error) {
        actions.setReportFileUrl([]);
        throw error
      });

  }),

  userNotifications: thunk(async (actions, payload) => {
    actions.setUserNotificationsList([]);
    await reportService
      .userNotifications(payload)
      .then(function (response) {
        actions.setUserNotificationsList(response);
        return response;
      })
      .catch(function (error) {
        actions.setUserNotificationsList([]);
        throw error
      });
  }),

  getPreSignedUrl: thunk(async (actions, payload) => {
    return await reportService.getPreSignedUrl(payload);
  }),
  postCustomReportMetaData: thunk(async (action, payload)=>{
    return await reportService.postCustomReportMetaData(payload);
  }),
  updateCustomReportMetaData: thunk(async (action, payload)=>{
    return await reportService.updateCustomReportMetaData(payload.PK, payload.values);
  }),
  updateCustomReportMetaQuery: thunk(async (action, payload)=>{
    return await reportService.updateCustomReportMetaQuery(payload.PK, payload.data);
  }),

  updatPublicPrivateStatus: thunk(async (actions, payload, helpers) => {
    const state = helpers.getState();
    const response = await reportService.updatPublicPrivateStatus(payload);
    for (let i = 0; i < state.customReportList.length; i++) {
      if (state.customReportList[i].PK === payload.PK) {
        state.customReportList[i].is_public = payload.is_public;
        state.customReportList[i].visibility = payload.is_public === 'y' ? "Public" : "Private";
        break;
      }
    }
    actions.setCustomReportList([...state.customReportList]);
    return response;
  }),
};

export default reportModel;
